<template>
  <div class="content" v-if="dataReady">
    <div class="row text-left">
      <div class="col-md-12">
        <p class="text-black-50">
          Новый клиент
          <i v-on:click="addNewOne" class="tim-icons icon-single-02"></i>
        </p>
      </div>
    </div>
    <big-one :content="content" :type = "type" tuning="true" :a-page="true" :new-one="newOne"></big-one>
  </div>
</template>
<script>

const clientName = {header: "Ф.И.О.", name: "name", show: true, sort: true, direction: false, contains: ""};
const clientBirthDay = {header: "Дата рождения", name: "birthdate", show: true, sort: true, direction: true};
const clientDisabledCategory = {header: "Категория инвалидности", name: "disabledCategory.name", show: true, sort: true, direction: true, entityFilter: true, entityField: 'disabledCategory', entity: 'disabledCategory', entityValue: null};
const clientLastCallDate = {header: "Дата последнего звонка", name: "lastCallTime", show: true, valueFilter: true, before: null, after: null, sort: true, direction: true, date: true};
const clientNextCallDate = {header: "Дата следующего звонка", name: "nextCallTime", show: true, valueFilter: true, before: null, after: null, sort: true, direction: true, date: true};
const callsExecutor = {header: "Исполнитель", name: "lastCaller", show: false, contains: ""};
const clientAddress = {header: "Адрес", name: "contact.address", show: true, contains: ""};
const isArchivedSelector = {selector: true, title: "Статус клиентов", name: "archivedDate", selectorList: null, contains: "null"}

export default{
  data() {
    return {
      type: "client",
      content: [clientName, clientBirthDay, clientDisabledCategory, callsExecutor, clientLastCallDate, clientNextCallDate, clientAddress, isArchivedSelector],
      newOne: null,
      dataReady: false
    }
  },
  methods: {
    addNewOne() {
      let object = {name: '', id: 0, contact:{}};
      this.newOne = ({object: object, id: object.id, view: 'edit'});
    }
  },
  async mounted() {
    isArchivedSelector.selectorList = await this.$repo.getSelector("archived");
    this.dataReady = true;
  }
}
</script>
<style>
</style>
